import globalConsent from '../ads/gdpr/globalConsent';
import { logDebugging } from '../log/logger';
import AdParams from '../tracker/adparams';
import contentCommonParams from '../tracker/contentCommonParams';
import contentParams from '../tracker/contentParams';
import TpxPlayerTracker from '../tracker/tpxplayertracker';

export default class TrackerManager {
  constructor(config) {
    this.config = config;
  }

  initTracker(playlistDataModel) {
    this.playlistDataModel = playlistDataModel;
    this.tracker = new TpxPlayerTracker('CONTENT');

    this.sendPlayerLoaded();
  }

  sendPlayerLoaded() {
    if (globalConsent.geo) {
      const commonParamsTracker = contentCommonParams(this.config, null, this.tracker.customerId);
      logDebugging(commonParamsTracker);

      this.tracker.setComonContentParams(commonParamsTracker);
      this.tracker.setComonParams(null, null);
      const contentpar = contentParams(this.config, this.playlistDataModel?.isVideoProducer());

      this.tracker.setContentParams(contentpar);
      logDebugging('sendPlayerLoaded');
      this.tracker.sendPlayerLoaded();
    } else {
      setTimeout(() => {
        logDebugging('sendPlayerLoaded timeout....');
        this.sendPlayerLoaded();
      }, 500);
    }
  }

  resetDataTracker() {
    try {
      if (this.tracker.contentParams) {
        this.tracker.contentParams.con_id = this.playlistDataModel.getItemSelected().id;
        this.tracker.contentParams.con_vi_id = `${parseInt(Math.random() * 10000, 10)}${Date.now()
          .toString()
          .substr(-4)}${parseInt(Math.random() * 10000000000, 10)}`;
        this.tracker.contentParams.con_vi_ts =
          globalConsent.geo?.timestamp || Math.floor(new Date().getTime());
      }
    } catch (e) {
      logDebugging(e);
    }
  }

  sendLoadingTracker(params) {
    const adParams = new AdParams();
    adParams.setExtraClient(params);
    adParams.setErrorCode(params);
    adParams.setErrorType('adLoadingTime');
    this.tracker.sendError(adParams);
  }

  sendTrackerByEvent(event) {
    if (this.playlistDataModel.looped) return;
    this.tracker.sendImpression(event);
  }
}
